export default "__VITE_ASSET__BSA2CTgn__"